<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { AUTH_LOGOUT } from "./store/actions/auth";
export default {
  methods: {
    logout() {
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push("/login"));
    },
  },
};
</script>
<style>
#app {
  font-family: Ubuntu;
  -webkit-font-smoothing: antialiased;
  /* -moz-osx-font-smoothing: grayscale; */
  /* text-align: center; */
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

.shdw {
  box-shadow: 0 0 0.62rem 0 rgba(0, 0, 0, 0.2);
}
.brdrad {
  border-radius: 0.63rem;;
}
.txt-grey {
  color: rgba(59, 59, 59, 0.8);
}
/* a {
  text-decoration: none !important;
  color: rgba(59, 59, 59, 0.8);
} */
.lbl {
  font-size: 0.7rem;
}
.sdbr{
  padding: 0px !important;
}
.cap {
  text-transform: capitalize;
}
</style>
